module.exports = __webpack_public_path__ + "afff247381e7ebe7d31b609f33eca644.svg";